// extracted by mini-css-extract-plugin
export default {"block":"NoStepsMatch_block__ozLr9","text":"NoStepsMatch_text__OUqTA","boldText":"NoStepsMatch_boldText__PGegd"};